import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Chart from './Chart/Chart.js';
import DataSeries from './DataSeries.js';

var StyledChart = /*#__PURE__*/styled(Chart).withConfig({
  componentId: "sc-xabapv-0"
})(["font-family:", ";"], function (props) {
  return props.theme.constellation.fonts.sansSerif;
});

// eslint-disable-next-line zillow/react/prefer-stateless-function
var DonutChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DonutChart, _Component);
  function DonutChart() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = DonutChart.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      cx = _this$props.cx,
      cy = _this$props.cy,
      width = _this$props.width,
      height = _this$props.height,
      data = _this$props.data,
      title = _this$props.title,
      centerText = _this$props.centerText,
      centerValue = _this$props.centerValue,
      valueFormatter = _this$props.valueFormatter,
      colors = _this$props.colors,
      radius = _this$props.radius,
      hideLabels = _this$props.hideLabels,
      smallCenterLabel = _this$props.smallCenterLabel,
      innerRadius = _this$props.innerRadius;
    var transform = "translate(" + (cx || width / 2) + "," + (cy || height / 2) + ")";
    var values = data.map(function (item) {
      return item.value;
    });
    var labels = data.map(function (item) {
      return item.label;
    });
    return /*#__PURE__*/React.createElement(StyledChart, {
      width: width,
      height: height,
      title: title
    }, /*#__PURE__*/React.createElement(DataSeries, {
      centerText: centerText,
      centerValue: centerValue,
      valueFormatter: valueFormatter,
      labels: labels,
      colors: colors,
      transform: transform,
      data: values,
      width: width,
      height: height,
      radius: radius,
      hideLabels: hideLabels,
      smallCenterLabel: smallCenterLabel,
      innerRadius: innerRadius
    }));
  };
  return DonutChart;
}(Component);
DonutChart.defaultProps = {
  title: ''
};
DonutChart.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array,
  colors: PropTypes.func,
  cx: PropTypes.number,
  cy: PropTypes.number,
  radius: PropTypes.number,
  title: PropTypes.string,
  hideLabels: PropTypes.bool,
  smallCenterLabel: PropTypes.bool,
  innerRadius: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  centerText: PropTypes.string,
  centerValue: PropTypes.number,
  valueFormatter: PropTypes.func
} : {};

export { DonutChart as default };
